import * as React from 'react';
import { addDays } from 'owa-datetime';
import { OwaDate } from 'owa-datetime';
import { formatShortMonthDay, formatShortWeekDay, formatWeekDay } from 'owa-datetime';
import { observer } from 'mobx-react';
import { isPastDate, isToday } from 'owa-observable-datetime';

let styles = require('./CalendarDateHeader.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CalendarDateHeaderProps {
    displayDate: OwaDate;
    formatHeader: (date: OwaDate) => string;
    onSurfaceClick?: (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        props?: any,
        selectedCalendarId?: string
    ) => void;
    style?: React.CSSProperties;
    calendarFolderId?: string;
    forwardedRef?: React.Ref<HTMLDivElement>;
}

/**
 * This panel shows date headers for surface columns
 */
@observer
export default class CalendarDateHeader extends React.Component<CalendarDateHeaderProps, {}> {
    render() {
        const { displayDate, children, forwardedRef } = this.props;
        const isPast = isPastDate(displayDate);
        const isTodayDate = isToday(displayDate);
        const shouldShowMonthString = displayDate.getDate() == 1 || isTodayDate;
        return (
            <div
                ref={forwardedRef}
                className={classNames(styles.header, styles.weekHeader, {
                    pastDay: isPast,
                    selectedHeader: isTodayDate,
                    containsAddon: !!children,
                })}
                onClick={this.openQuickCompose}
                style={this.props.style}>
                {this.renderHeaderContent(shouldShowMonthString, isTodayDate, isPast)}
                {children}
            </div>
        );
    }

    private openQuickCompose = (ev?: React.MouseEvent<HTMLElement>) => {
        this.props.displayDate;
        this.props.onSurfaceClick(
            this.props.displayDate,
            addDays(this.props.displayDate, 1),
            true,
            false /* No click and drag scenario */,
            this.props.calendarFolderId
        );
    };

    private renderHeaderContent(
        shouldShowMonthString: boolean,
        isTodayDate: boolean,
        isPast: boolean
    ): JSX.Element {
        let { displayDate, formatHeader } = this.props;

        if (shouldShowMonthString) {
            let header = [formatShortMonthDay(displayDate), formatWeekDay(displayDate)].join(' ');
            let headerStyleClassName = classNames(
                styles.monthValueInHeader,
                styles.enlargedHeader,
                isTodayDate ? styles.monthValueInHeader : styles.futureHeader,
                {
                    dayHeaderCurrentDay: isTodayDate,
                }
            );

            return (
                <div className={headerStyleClassName}>
                    <time title={header}> {formatShortMonthDay(displayDate)} </time>
                    <div className={classNames(styles.dayHeader)} title={header}>
                        {formatShortWeekDay(displayDate)}
                    </div>
                </div>
            );
        } else {
            let header = formatHeader(displayDate);
            let headerStyleClassName = classNames(
                styles.enlargedHeader,
                isPast ? styles.pastHeader : styles.futureHeader
            );
            return (
                <div className={headerStyleClassName}>
                    <time title={header}> {header} </time>
                    <div className={styles.dayHeader}>{formatShortWeekDay(displayDate)}</div>
                </div>
            );
        }
    }
}
